import React from 'react';
import './css/loading.css'

interface LoadingProps{
    isOpen: boolean
}

const LoadingComponent: React.FC<LoadingProps> = ({isOpen}) => {
    return (
        <div className={`${
            isOpen ? 'w-full h-full flex justify-center items-center bg-[#80808091] fixed z-[1]' 
            : 'hidden'}`}>
            <span className="loader"></span>
        </div>
    );
};

export default LoadingComponent;